import axios from 'axios';
import { auth } from '../auth/index';

export const HTTP = axios.create({

  //Enter Address for Api Here
  //baseURL: 'http://localhost:62805/api/',

  //Test Environment
  //baseURL: 'http://test.mywalletwatcher.com/api/',
  baseURL: 'https://testapi.mywalletwatcher.com/api/',

  //Production
  //baseURL: 'https://api.mywalletwatcher.com/api/',

  headers: {
    //Authorization: auth.getAuthHeader()
    Authorization: 'Bearer ' + localStorage.getItem('access_token')
  }

})



// WEBPACK FOOTER //
// ./src/api/httpCommon.js